import type { INudgeConfig, ENudgeId } from './types';
import { createFirstDraftNudge } from './configs/create-first-draft.nudge';

/**
 * Central registry of all nudge configurations.
 *
 * The NudgeManager iterates this list to find the highest-priority
 * active nudge whose condition is met and hasn't been dismissed.
 */
export const NUDGE_REGISTRY: readonly INudgeConfig[] = [createFirstDraftNudge];

/**
 * Looks up a nudge config by its ID.
 *
 * @param id - Nudge identifier
 * @returns The nudge config, or undefined if not registered
 */
export function getNudgeConfig(id: ENudgeId): INudgeConfig | undefined {
  return NUDGE_REGISTRY.find(n => n.id === id);
}
